import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash-es/isEmpty'

import { createProvider } from '../../../api'
import { EMPTY_LIST } from '../../../constants/common'
import { useInlineNotifications } from '../../../hooks'
import { parseServerValidation } from '../../../utils/validation'
import { FormikForm } from '../../Formik'

import { FormFields } from './FormFields'
import { PROVIDER_FORM_INITIAL_VALUES } from './ProviderForm.constants'
import {
  getPayload,
  getValidationSchema,
  parseProviderFormServerError,
} from './ProviderForm.utils'

import * as styles from './ProviderForm.module.css'

function ProviderForm({
  FormContainer,
  containerProps,
  initialValues = PROVIDER_FORM_INITIAL_VALUES,
  onCancel,
  onSuccess,
  ...restProps
}) {
  const { t } = useTranslation()

  const [files, setFiles] = useState(EMPTY_LIST)

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const validationSchema = getValidationSchema()

  function handleSubmit(values, { setErrors, setSubmitting }) {
    const payload = getPayload({ files, values })

    createProvider(payload)
      .then(({ data }) => {
        onSuccess?.(data)
      })
      .catch(({ response }) => {
        if (!isEmpty(response)) {
          setSubmitting(false)
          setErrors(
            parseServerValidation(
              parseProviderFormServerError(response.data.errors, t)
            )
          )
        }
      })
  }

  return (
    <FormikForm
      enableReinitialize
      Container={FormContainer}
      containerProps={{
        ...containerProps,
        files,
      }}
      formProps={{
        className: styles.formBody,
      }}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <FormFields
        {...restProps}
        files={files}
        notifications={notifications}
        setFiles={setFiles}
        onCancel={onCancel}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default ProviderForm
